import React from 'react';
import BannerSection, { BannerSectionProps } from '../BannerSection';
import Form, { FormProps } from '../../molecules/Form';

export interface BannerNewsletterSectionProps extends BannerSectionProps {
    form?: FormProps;
}

export default function BannerNewsletterSection({
    form,
    ...props
}: BannerNewsletterSectionProps) {
    return (
        <BannerSection {...props}>
            {!!form && <Form {...form} className="pt-xxl lg:pt-lg" />}
        </BannerSection>
    );
}
